import { initFederation } from '@angular-architects/native-federation';
import { environment } from './environments/environment';
import { resolveFederationManifest } from './app/plugin/federation-manifest-resolver';

resolveFederationManifest(environment, window.location.search)
  .then((manifest) => initFederation(manifest))
  .catch(err => console.error(err))
  .then(() => import('./bootstrap'))
  .catch(err => console.error(err));
